import {css} from 'styled-components';

/**
 * Hover-reveal scroll bar: the track is hidden at rest and a styled thumb appears while the
 * pointer is over the scroll area. Chrome/Safari only (webkit pseudo-elements) — Firefox falls
 * back to the design-system native Scrollbar (which uses scrollbar-width/scrollbar-color).
 *
 * Contains ONLY the `&::-webkit-scrollbar*` rules so each call site chooses the parent selector:
 * apply it directly on a scrollable element (e.g. a styled `ScrollArea`), or nest it inside the
 * design-system Scrollbar's `.scrollbar { ${hoverRevealScrollbar} }` wrapper. (PIKA-627)
 */
export const hoverRevealScrollbar = css`
	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}
	&::-webkit-scrollbar-track {
		background: transparent;
	}
	&::-webkit-scrollbar-thumb {
		background: transparent;
		border-radius: 6px;
		border: 3px solid transparent;
		background-clip: content-box;
	}
	&:hover::-webkit-scrollbar-thumb {
		background: rgba(0, 0, 0, 0.32);
		background-clip: content-box;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: rgba(0, 0, 0, 0.48);
		background-clip: content-box;
	}
`;
